module.exports = __webpack_public_path__ + "static/img/banner-1.217160fa.png";